import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import { TextField, InputBase, Checkbox, InputAdornment, IconButton, Select, MenuItem, FormControl, FormHelperText, Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import desc from '../../../../assets/img/svg/desc.svg';
import { useNavigate } from "react-router-dom";
import Delete from '../../../../assets/img/svg/delete.svg'
import docIcon from "../../../../assets/img/svg/docIcon.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery"
import { addwpdocinfo } from "../../../../actions/WPAction";
import del from "../../../../assets/img/svg/Del.svg"
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import moment from "moment"

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);


class AddWP extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            cancel: false,
            Docs: [],
            Error: {
                "DescriptionError": false,
                "PermitDateError": false,
                "PermitTypeError": false,
            },
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Description": "",
                "PermitDate": "",
                "PermitType": "",
                "Modifiedby": ''
            }
        }
    }

    componentDidMount() {
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.addData.Modifiedby = localStorage.getItem("UserRoles");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    OpenPopup = (i) => {
        this.state.delindex = i;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }

    DeleteItem = () => {
        let tempData = [];
        this.state.Docs.map((i, a) => {
            if (a != this.state.delindex) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#WORK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Workpermits1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Workpermits").addClass("d-none");
        $("#Workpermits").removeClass("d-block");
        $("#WPL").removeClass("active-color");
        $("#WPT").removeClass("fw-bolder");
    }

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#WORK1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Workpermits1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Workpermits").removeClass("d-none");
        $("#Workpermits").addClass("d-block");
        $("#WPL").addClass("active-color");
        $("#WPT").addClass("fw-bolder");
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });

            this.props.navigate(`/workpermits`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });

        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/workpermits")
    };

    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (node == "Description") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData[node] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[node] = e.target.value;
            this.setState({});
        }
    };

    setCheckbox = (str) => {
        this.state.Docs.map((i) => {
            if (str == i.fileName) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });

        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                fileName: a.name,
                size: a.size,
                check: false,
                fdata: a,
            }
            this.state.Docs.push(upload)
            this.setState({})
        })
    };

    AddSave = () => {
        if (this.state.addData.Description.trim() === "") {
            this.state.Error.DescriptionError = true;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        else {
            this.state.Error.DescriptionError = false;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        if (this.state.addData.PermitDate == "") {
            this.state.Error.PermitDateError = true;
            this.setState({})
        }
        else {
            this.state.Error.PermitDateError = false;
            this.setState({})
        }
        if (this.state.addData.PermitType == "") {
            this.state.Error.PermitTypeError = true;
            this.setState({})
        }
        else {
            this.state.Error.PermitTypeError = false;
            this.setState({})
        }
        if (this.state.addData.Description !== '' && this.state.addData.PermitDate !== '' && this.state.addData.PermitType !== '') {
            this.props.dispatch({ type: "CANCEL", data: false });
            let formData = new FormData()
            if (this.state.Docs.length > 0) {
                Array.from(this.state.Docs).forEach(async (a) => {
                    formData.append("attachments", a.fdata)
                })
            }
            this.addwpdocinfo(this.state.addData, formData)
        }
    }

    addwpdocinfo = (data, formData) => {
        let apiUrl = API.WP_LISTVIEW;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
            // headers : {
            //   'content-type': 'application/json'
            // }
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.adduploadwpdocinfo(formData, response.data)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    adduploadwpdocinfo = (data, id) => {
        let apiUrl = API.WP_LISTVIEW + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })

        axios({
            method: "POST",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/workpermits")
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-4 w-50 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"WORK" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="WORK" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-8 pt-2 mt-5 w-50 ">
                                    <h4>Add New Work Permits </h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="text-center">
                                    <button className={classes.button} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={classes.button} onClick={this.AddSave} ><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button}  pl-3`} onClick={this.AddCancel1} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Add New Work Permits</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex"}>Description&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    {this.state.Error.DescriptionError ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            multiline
                                            value={this.state.addData.Description}
                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                            rows={4}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        /> : <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            value={this.state.addData.Description}
                                            onChange={(e) => { this.handleInputChange(e, "Description") }}
                                            rows={4}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Description?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Description?.length}/500 Characters left</label>
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "px-0 mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end text-right m-0 d-flex"}>Permit Date&nbsp;:
                                        <div className={`${classes.MuiFormHelperTextcontained}`}>
                                            *
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-lg-4 col-md-12 pt-1 pb-3" : "col-lg-10 col-md-10 pt-4 pb-4"}`}>
                                    {this.state.Error.PermitDateError ?
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            id="type-date"
                                            value={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "PermitDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                        :
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            id="type-date"
                                            value={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.PermitDate && moment(this.state.addData.PermitDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "PermitDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                              }}
                                        />
                                    }
                                </div>
                            </div>
                            <div className={`row mx-1 ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 pt-1 px-0 col-lg-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "mt-4 float-end text-right d-flex"}>Permit Type&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-xl-7  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 col-lg-12 pt-1 pb-2" : "col-lg-10 col-md-10 pt-4 pb-3"}`}>
                                    {this.state.Error.PermitTypeError ?
                                        <>
                                            <RadioGroup row value={this.state.addData.PermitType} onChange={(e) => { this.handleInputChange(e, "PermitType") }} fullWidth>
                                                <FormControlLabel value="Hot Work Permit" control={<Radio color="default" className={classes.error} />} label="Hot Work Permit" size="small" />
                                                <FormControlLabel value="Cold Work Permit" control={<Radio color="default" className={classes.error} />} label="Cold Work Permit" size="small" />
                                            </RadioGroup>
                                        </>
                                        :
                                        <RadioGroup row value={this.state.addData.PermitType} onChange={(e) => { this.handleInputChange(e, "PermitType") }} fullWidth>
                                            <FormControlLabel value="Hot Work Permit" control={<Radio color="default" />} label="Hot Work Permit" size="small" />
                                            <FormControlLabel value="Cold Work Permit" control={<Radio color="default" />} label="Cold Work Permit" size="small" />
                                        </RadioGroup>}
                                </div>
                            </div>
                            <div className={`row mx-1 ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right" : "px-0 mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? " mt-2" : "float-end m-0 text-right pt-4"}>Attachments&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        onChange={(e) => { this.UploadFile(e) }}
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }} />
                                    <input
                                        type="file"
                                        multiple="multiple"
                                        hidden
                                        onChange={(e) => { this.UploadFile(e) }}
                                        ref={this.inputFile}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                    <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                        {this.state.Docs && this.state.Docs.map((i, ind) => {
                                            return (
                                                <div className={`col-6 col-lg-4 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${window.innerWidth < 360 ? "col-12" : this.state.isMobile ? "col-md-4 col-sm-4" : "col-md-6 col-sm-6"}`}>
                                                    <div className="row d-flex pr-3">

                                                        <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                            <div className="pt-2 overflow">{i.fileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.size / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                        </div>
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pl-1 mt-2 pt-1 pr-2">
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
    };
}

AddWP.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddWP))
);
